// src/app/supplier/supplier-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupplierComponent } from './supplier.component';
import { ProcurementPackageComponent } from './procurement-package/procurement-package.component';
import { SelectSupplierComponent } from './select-supplier/select-supplier.component';
import { VerifySelectionComponent } from './verify-selection/verify-selection.component';
import { CompletedComponent } from './completed/completed.component';

const routes: Routes = [
  {
    path: '',
    component: SupplierComponent,
    children: [
      { path: 'purchase-order', component: ProcurementPackageComponent },
      { path: 'select-supplier', component: SelectSupplierComponent },
      { path: 'verify-selection', component: VerifySelectionComponent },
      { path: 'completed', component: CompletedComponent },
      { path: '', redirectTo: 'purchase-order', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierRoutingModule {}
